


















import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'

@Component<WizardNavigation>({
  props: {
    currentStep: Number,
    totalSteps: Number,
    title: String,
    link: String,
    linkText: String,
    lastStepText: String,
    disableNextButton: Boolean,
    disableNextStepReason: String,
    disabledBackButton: Boolean,
    wizardType: String
  },
  watch: {
    selectedOccupations () {
      this.changeShowTop()
    }
  }
})

export default class WizardNavigation extends Vue {
  /**
   * Props variables
   */
  currentStep: number | undefined
  totalSteps: number | undefined
  title: string | undefined
  link: string | undefined
  linkText: string | undefined
  lastStepText: string | undefined
  disableNextButton: boolean = false
  disableNextStepReason: string | undefined
  disabledBackButton: boolean = false
  wizardType: string | undefined

  /**
   * Component state variables
   */
  showTop: boolean = true

  /**
   * Lifecycle
   */
  mounted() {
    this.changeShowTop()
  }

  /**
   * Getters
   */
  get getNextButtonText(): string {
    return this.currentStep === this.totalSteps ? this.lastStepText : this.t.general_Next
  }

  get t (): any {
    return AppModule.translations
  }

  get lowerCaseTranslation (): string {
    return  this.t.general_Of !== undefined ? this.t.general_Of.toLowerCase() : ""
  }

  get selectedOccupations (): number {
    return JobMatchOccupationModule.selectedOccupations.length
  }

  /**
   * Methods
   */
  back() {
    this.$emit('back')
  }

  next() {
    this.$emit('next')
  }

  changeShowTop () {
    if (this.wizardType === 'Job Match') {
      this.showTop = this.selectedOccupations > 0 ? true : false
    }
  }
}
